import { tokens } from "@opendoor/tokens-studio/dist/bricks-next/tokens/Components";
import { useProps } from "@tamagui/core";
import LottieView from "lottie-react-native";
import SpinnerWithoutLogo from "../../assets/animations/SpinnerNoLogo.json";
import SpinnerWithLogo from "../../assets/animations/SpinnerWithLogo.json";
import { Box } from "../Box";
import { jsx } from "react/jsx-runtime";
const { loaders: loaderTokens } = tokens, Loader = ({
  backgroundColor,
  withLogo,
  onAnimationFailure,
  ...propsIn
}) => {
  const { size = "small" } = useProps(propsIn), loaderType = withLogo ? "spinnerWithLogo" : "spinnerNoLogo", width = loaderTokens.size[loaderType].width[size], height = loaderTokens.size[loaderType].height[size], bgColor = backgroundColor || loaderTokens.color.background.spinnerWithLogo;
  return /* @__PURE__ */ jsx(Box, { width, height, backgroundColor: bgColor, children: /* @__PURE__ */ jsx(
    LottieView,
    {
      style: { width: "100%", height: "100%" },
      source: withLogo ? SpinnerWithLogo : SpinnerWithoutLogo,
      autoPlay: !0,
      loop: !0,
      onAnimationFailure
    }
  ) });
};
export {
  Loader
};
